// Core deps
import { createApp } from 'vue';
import store from './store';
import router from '@/router/router';
import { BASE_URL, ENV, isProduction } from './environment';
import { logError } from '@/utils/error';
import App from '@/App.vue';
import { createPinia } from 'pinia';
import { initDirectives } from '@/V2/directives/directives';

// Third Party Libraries
import * as Sentry from '@sentry/vue';
import emitter from '@/bus';

// services
import ApiService from '@/shared/services/api.service';
import { OnboardingService } from '@/shared/services/onboarding/onboarding.service';

// Stylesheets
import '../styles/custom.scss';

// App Init
ApiService.init(BASE_URL);

const app = createApp(App);
const pinia = createPinia();
app.config.globalProperties.emitter = emitter;
app.use(router);
app.use(store);
app.use(pinia);
app.mount('#app');

// config
app.config.debug = import.meta.env.MODE === 'development';

// catch uncaught errors in the app and log them to Sentry
app.config.errorHandler = function (err) {
  // eslint-disable-next-line no-console
  console.error(err);
  logError(err);
};

// initialize directives
initDirectives(app);

OnboardingService.init();

if (isProduction) {
  Sentry.init({
    app,
    dsn: 'https://232fc7155ea34f31b7a781b2d2d62aa7@sentry.io/1384448',
    environment: ENV,
    integrations: [Sentry.browserTracingIntegration({ router })],
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && error.name === 'NavigationDuplicated') {
        event.fingerprint = ['NavigationDuplicated'];
      }
      return event;
    },
  });
}
